var path = 'batch/export/info/exportInfo.tpl.html';
var html = "<react-component name=\"activity-export-info\" />\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;